// extracted by mini-css-extract-plugin
export default {"buttonGroupContainer":"SelectDeliveryTypeSection_buttonGroupContainer__wNKPB"};